

export const diag_WH = (n, s = 'px') => {
    
    const ww = window.innerWidth ** 2
    const hh = window.innerHeight ** 2

    if (window.innerWidth >= 1200)
        return `${0.75 * Math.sqrt(ww + hh) * n / 1000}${s}`

    return `${ Math.sqrt(ww + hh) * n / 1000}${s}`
}